import PortalAppService from "../../../application/platform/portal-app-service";
import { IListAgreementsRequest } from "../../../model/base/request/list-agreements-request";
import { useAgreementsDispatch } from "./agreements-context";
import { ACTION_TYPES } from "./agreements-reducer";

export const useAgreementsController = () => {
    const dispatch = useAgreementsDispatch();

    const loadData = async (params: IListAgreementsRequest) => {
        try {
            // Limpa os dados antes de carregar novos
            dispatch({ type: ACTION_TYPES.CLEAR_AGREEMENTS });
            const agreementsData = await PortalAppService.requestAgreements(params);
            dispatch({ type: ACTION_TYPES.SET_AGREEMENTS, payload: agreementsData });
        } catch (error) {
            console.error('Error loading agreements data:', error);
        }
    };

    const loadDetail = async (id: number) => {
        try {
            const agreementDetail = await PortalAppService.requestAgreementDetail(id);
            dispatch({ type: ACTION_TYPES.SET_AGREEMENT_DETAIL, payload: agreementDetail });
        } catch (error) {
            console.error('Error loading agreement detail:', error);
        }
    };

    return { loadData, loadDetail };
};
